import { memo } from 'react';

import usePlankTableStore from '../../hooks/usePlankTableStore';

import TableRowRegionaal from './TableRow/TableRowRegionaal';

import tableStyles from './TableRegionaal.module.css';

const DDPTableRow = memo(TableRowRegionaal);

const TableKnoop = () => {
  const rows = usePlankTableStore((state) => state.tableRegionaal.rows);
  return (
    <>
      {rows.length > 0 && (
        <div className={tableStyles.tableRowsStyle}>
          {rows.map((knoop) => (
            <DDPTableRow key={knoop} knoop={knoop} />
          ))}
        </div>
      )}
    </>
  );
};
export default TableKnoop;
